module.exports = __webpack_public_path__ + "static/media/golfer-3-a.9d167363.png";